import script from "./DataTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./DataTitle.vue?vue&type=script&setup=true&lang=js"

import "./DataTitle.vue?vue&type=style&index=0&id=51f786ec&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Andre\\OneDrive\\Desktop\\Documents\\GitHub\\vue-covid-tracker\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51f786ec"]])

export default __exports__